enum DigitalDocumentStatus {
    Sent = 'SENT',
    Signed = 'SIGNED',
}

export default DigitalDocumentStatus;
